<template>
    <div class="shariff order-2 order-md-1">
        <ul class="theme-grey orientation-vertical col-345">
            <li
                v-if="!displaySingleShareBtn"
                class="shariff-button whatsapp d-none d-lg-block"
            >
                <a
                    :href="whatsApp.url"
                    rel="nofollow"
                    :title="whatsApp.title"
                    role="button"
                    :aria-label="whatsApp.title"
                    @click="share($event, whatsApp.url, 'whatsApp')"
                ><span class="fa fab fa-whatsapp"/></a>
            </li>
            <li
                v-if="!displaySingleShareBtn"
                class="shariff-button facebook d-none d-lg-block"
            >
                <a
                    :href="facebook.url"
                    data-rel="popup"
                    rel="nofollow"
                    :title="facebook.title"
                    role="button"
                    :aria-label="facebook.title"
                    @click="share($event, facebook.url, 'facebook')"
                ><span class="fa fab fa-facebook-f"/></a>
            </li>
            <li
                v-if="!displaySingleShareBtn"
                class="shariff-button pinterest d-none d-lg-block"
            >
                <a
                    :href="pinterest.url"
                    data-rel="popup"
                    rel="nofollow"
                    :title="pinterest.title"
                    role="button"
                    :aria-label="pinterest.title"
                    @click="share($event, pinterest.url, 'pinterest')"
                ><span class="fa fab fa-pinterest-p"/></a>
            </li>
            <li
                v-if="displaySingleShareBtn"
                class="shariff-button d-none d-md-block"
            >
                <a
                    data-rel="popup"
                    rel="nofollow"
                    :title="$translate('modeherz::SocialMediaClient.socialMediaShare')"
                    role="button"
                    :aria-label="$translate('modeherz::SocialMediaClient.socialMediaShare')"
                    @click="shareViaApi"
                ><span class="fa fa-share-alt"/><span class="share_text mr-4">{{ $translate('modeherz::SocialMediaClient.socialMediaShare') }}</span></a>
            </li>
        </ul>
    </div>
</template>

<script>

    import whatsAppConfig from './share-buttons/whatsapp';
    import pinterestConfig from './share-buttons/pinterest';
    import facebookConfig from './share-buttons/facebook';
    import Constants from '../../constants/ItemSearch';

    export default {
        name: 'ShareButtons',
        props: {
            variation: {
                type: Object,
                required: true,
            },
            titleA: {
                type: String,
                default: '',
            },
        },
        data() {
            return {
                title: this.variation.texts.name1,
                supportsShareApi: true,
                isNativeMobile: false,
            };
        },
        computed: {
            displaySingleShareBtn() {
                return this.supportsShareApi && this.isNativeMobile;
            },
            plainUrl() {
                return 'https://www.modeherz.de/' + this.variation.texts.urlPath + '_' + this.variation.item.id + '_' + this.variation.variation.id;
            },
            url() {
                return encodeURIComponent(this.plainUrl);
            },
            img() {
                return this.variation.images.all[0].url;
            },
            whatsApp() {
                return {
                    url: whatsAppConfig.shareUrl(this.title, this.url),
                    title: whatsAppConfig.title[App.language],
                    shareText: whatsAppConfig.shareText[App.language],
                };
            },
            pinterest() {
                return {
                    url: pinterestConfig.shareUrl(this.title, this.url, this.img),
                    title: pinterestConfig.title[App.language],
                    shareText: pinterestConfig.shareText,
                };
            },
            facebook() {
                return {
                    url: facebookConfig.shareUrl(this.title, this.url),
                    title: facebookConfig.title[App.language],
                    shareText: facebookConfig.shareText[App.language],
                };
            },
        },
        mounted() {
            this.title = document.title;
            this.supportsShareApi = !!navigator.share;
            this.isNativeMobile = this.isMobileDevice() !== 'unknown';
        },
        methods: {
            share(e, shareUrl, target) {
                e.preventDefault();
                window.open(shareUrl, '_blank', 'width=600,height=460');
                document.dispatchEvent(new CustomEvent('onProductShare', {
                    detail: {
                        'method': target,
                        'content_type': 'url',
                        'item_id': this.variation.variation.id,
                        // 'value': <value>
                    },
                }));
            },
            async shareViaApi() {
                const shareData = {
                    url: this.plainUrl,
                };
                try {
                    await navigator.share(shareData);
                    document.dispatchEvent(new CustomEvent('onProductShare', {
                        detail: {
                            'method': 'navigator.share',
                            'content_type': 'url',
                            'item_id': this.variation.variation.id,
                            // 'value': <value>
                        },
                    }));
                } catch (err) {
                    console.log('sharing url failed', err);
                }
            },
            isMobileDevice() {
                const userAgent = navigator.userAgent || navigator.vendor || window.opera;

                // Windows Phone must come first because its UA also contains "Android"
                if (/windows phone/i.test(userAgent)) {
                    return 'Windows Phone';
                }

                if (/android/i.test(userAgent)) {
                    return 'Android';
                }

                // iOS detection from: http://stackoverflow.com/a/9039885/177710
                if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                    return 'iOS';
                }

                // iPad check
                if (navigator.userAgent.match(/Mac/) && navigator.maxTouchPoints && navigator.maxTouchPoints > 2) {
                    return 'iOS';
                }

                return 'unknown';
            },
        },
    };
</script>

<style scoped>

</style>
